import Swal from "sweetalert2";
import i18n from '../i18n';
import 'sweetalert2/src/sweetalert2.scss'

const SwalLoad = () => {
    Swal.fire({
        heightAuto: false,
        icon: "info",
        html: "Loading... Please Wait",
        willOpen: () => {
            Swal.showLoading();
        },
        showConfirmButton: false,
        allowOutsideClick: false,
    });
};
const SwalErr = async (text) => {
    var res = Swal.fire({
        icon: "error",
        html: text,
        customClass: {
            confirmButton: "btn btn-success",
        },
        // buttonsStyling: false,
        allowOutsideClick: false,
        confirmButtonText: i18n.t('common.ok'),
    });
    return res;
};
const SwalInfo = async (text) => {
    var res = Swal.fire({
        icon: "info",
        html: text,
        customClass: {
            confirmButton: "btn btn-info",
        },
        // buttonsStyling: false,
        allowOutsideClick: false,
        confirmButtonText: i18n.t('common.ok'),
    });
    return res;
};
const SwalSuccess = async (text, { html = "" }) => {
    var res = await Swal.fire({
        icon: "success",
        html: html ? html : text,
        customClass: {
            confirmButton: "btn btn-success",
        },
        timer: 2000,
        // buttonsStyling: false,
        allowOutsideClick: false,
        confirmButtonText: i18n.t('common.ok'),
    });

    return res;
};

const SwalConfirm = async (text) => {
    var result = await Swal.fire({
        title: text,
        icon: "warning",
        buttonsStyling: false, // 🔥 สำคัญมาก
        customClass: {
            confirmButton:
                "bg-red-500 hover:bg-red-700 text-white font-medium px-4 py-2 rounded-lg",
            cancelButton:
                "bg-gray-200 hover:bg-gray-400 text-gray-800 font-medium px-4 py-2 rounded-lg mr-2"
        },
        confirmButtonText: i18n.t('common.confirm'),
        cancelButtonText: i18n.t('common.cancel'),
        reverseButtons: true,
        showCancelButton: true,
    });

    return result;
};

const SwalClose = () => {
    Swal.close();
};

const CSwl = {
    SwalLoad: SwalLoad,
    SwalErr: SwalErr,
    SwalClose: SwalClose,
    SwalSuccess: SwalSuccess,
    SwalConfirm: SwalConfirm,
    SwalInfo: SwalInfo
};

export default CSwl;
